export const ADVANCED_ABORT_SIGNAL_PRIVATE = Symbol('advanced-abort-signal-private');
//# sourceMappingURL=privates.js.map